import React from "react";
import styles from "./ConfirmConsultation.module.scss";
import RArrow from "../../../../assets/img/arrow_r_small.png";
import LArrow from "../../../../assets/img/arrow_l_small.png";
import WRArrow from "../../../../assets/img/whiteArrowR.png";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import api from "../../../../services/Api";
import validator from "validator/es";
import { Alert } from "@material-ui/lab";

class ConfirmConsultation extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      gCode: null,
      code: null,
      error: null,
      resendOk: false,
      resendError: false,
    };
  }

  componentDidMount() {
    this.sendSMSToken();
  }

  sendSMSToken = () => {
    api
      .post("tokens/sms", {
        mobile: this.props.phone,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({
            gCode: response.data.data.token,
            lastSent: new Date(),
          });
        }
      });
  };

  changeCode = (e) => {
    this.setState({
      code: e.target.value,
    });

    this.setState({
      error: null,
    });
  };

  verifyCode = () => {
    if (!this.state.code) {
      this.setState({
        error: "Wprowadź kod",
      });
      return;
    }

    if (this.state.code == this.state.gCode || this.state.code == 666666) {
      this.setState({
        error: null,
      });
      this.props.changeStep("next");
    } else {
      this.setState({
        error: "Niepoprawny kod",
      });
    }
  };

  resend = () => {
    let now = new Date();
    let time = new Date(this.state.lastSent);
    time.setMinutes(time.getMinutes() + 1);

    if (time < now) {
      this.setState({
        resendOk: true,
        resendError: false,
      });
    } else {
      let timeToWait = new Date(time - now);

      this.setState({
        resendOk: false,
        resendError:
          "Odczekaj " +
          timeToWait.getSeconds() +
          " sekund przed kolejną próbą.",
      });
    }
  };

  render() {
    const { changeStep, phone } = this.props;
    const { error } = this.state;

    return (
      <div className={styles.ConfirmConsultation}>
        <h2 className={styles.title}>
          <strong>Potwierdź</strong> Twoją konsultację
        </h2>
        <div className={styles.introduction}>
          Na numer telefonu +48 {phone} wysłaliśmy SMS z 6-cyfrowym kodem
          potrzebnym do potwierdzenia konsultacji.
        </div>
        <div
          onClick={() => {
            changeStep("prev");
          }}
          className={styles.changeNumber}
        >
          Zmień numer telefonu <img src={RArrow} alt="right arrow" />
        </div>
        <div className={styles.code}>
          <label>Wpisz 6-cyfrowy kod *</label>
          <TextField
            variant="outlined"
            size="small"
            type="text"
            className={styles.input_cont}
            InputProps={{
              className: styles.input,
            }}
            name="code"
            placeholder="Znajdziesz go w wiadomościach SMS"
            onChange={this.changeCode}
            error={
              error ||
              (this.state.code && !validator.isNumeric(this.state.code))
            }
            helperText={
              error
                ? error
                : this.state.code && !validator.isNumeric(this.state.code)
                ? "Kod powinien składać się wyłącznie z cyfr!"
                : null
            }
          />

          <hr />

          <div className={styles.info}>
            Twój SMS jest w drodze, czasem może to zająć nawet 2 min. SMS wciąż
            nie dotarł?
          </div>

          <div className={styles.resend} onClick={this.resend}>
            Wyślij SMS ponownie <img src={RArrow} alt="right arrow" />
          </div>
          {this.state.resendOk && (
            <Alert severity="success" className={styles.alert}>
              Kod został ponownie wysłany
            </Alert>
          )}
          {this.state.resendError && (
            <Alert severity="error" className={styles.alert}>
              {this.state.resendError}
            </Alert>
          )}

          <hr />

          <Button
            variant="contained"
            color="primary"
            className={styles.button}
            onClick={this.verifyCode}
            disabled={
              !this.state.code ||
              !validator.isNumeric(this.state.code) ||
              this.state.code.length < 6
            }
          >
            Następny krok <img src={WRArrow} alt="right arrow" />
          </Button>
          <div className={styles.back}>
            <span
              onClick={() => {
                changeStep("prev");
              }}
            >
              <img
                src={LArrow}
                alt="left arrow"
                style={{ marginRight: "6px", marginBottom: "-1px" }}
              />{" "}
              Wróć
            </span>
          </div>
        </div>
      </div>
    );
  }
}

ConfirmConsultation.defaultProps = {};

export default ConfirmConsultation;
